import React, { Component } from 'react'
import { connect } from 'react-redux'
import { hideUtilModal } from '../../redux/actions/miscActions'
import { Modal } from 'antd'
import Login from '../auth/Login'
import Register from '../auth/Register'

export class UtilModal extends Component {
  handleCancel=()=>{
    this.props.hideUtilModal()
  }
  render() {
    const { isUtilModalVisible, utilComp } = this.props.misc
    return (
      <div className="util-modal-container">
        <Modal
        className="util-modal"
        footer={null}
        visible={isUtilModalVisible}
        onCancel={this.handleCancel}
        >
          <div className="util-modal-content">
            {utilComp === 'register' ? <Register /> : null}
            {utilComp === 'login' ? <Login/> : null}         
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, { hideUtilModal})(UtilModal)
